export const deepClone = (obj) => JSON.parse(JSON.stringify(obj || {}));

export function mergeBlockPatch(prev, patch) {
  const next = { ...(prev || {}), ...(patch || {}) };
  if (patch?.config) next.config = { ...((prev && prev.config) || {}), ...patch.config };
  if (patch?.style) next.style = { ...((prev && prev.style) || {}), ...patch.style };
  return next;
}

export function mergeSectionPatch(section, patch) {
  const next = { ...section, ...patch };
  if (patch?.config) next.config = { ...(section.config || {}), ...patch.config };
  if (patch?.style) next.style = { ...(section.style || {}), ...patch.style };
  return next;
}

export function mergeServerSection(localSection, serverSection) {
  return {
    ...localSection,
    ...serverSection,
    enabled: serverSection?.enabled ?? localSection.enabled,
    type: serverSection?.type ?? localSection.type,
    template: serverSection?.template ?? localSection.template,
    config: { ...(localSection.config || {}), ...(serverSection?.config || {}) },
    style: { ...(localSection.style || {}), ...(serverSection?.style || {}) },
  };
}